import React, { useState } from 'react';
import { PROFESSIONS } from '../artistProfile';

export default function ArtistProfileFields({ artCategories, setArtCategories }) {
  const [search, setSearch] = useState('');
  const toggleArt = (category) => {
    const selected = artCategories.includes(category);
    setArtCategories(selected ? artCategories.filter((item) => item !== category) : [...artCategories, category]);
  };
  return <div className="artist-profile-fields">
    <fieldset>
      <legend>Your professions and skills *</legend>
      <p className="muted">Select multiple.</p>
      <label>Search professions and skills<input type="search" value={search} onChange={(event) => setSearch(event.target.value)} placeholder="Doctor, guitarist, app developer..." /></label>
      <p className="muted" aria-live="polite">{artCategories.length} selected</p>
      {!!artCategories.length && <div className="profession-selections">{artCategories.map((category) => <button key={category} type="button" className="secondary-button" aria-label={`Remove ${category}`} onClick={() => toggleArt(category)}>{category} &times;</button>)}</div>}
      <div className="art-options profession-options">{PROFESSIONS.filter((category) => category.toLowerCase().includes(search.trim().toLowerCase())).map((category) => <label className="art-option" key={category}>
        <input type="checkbox" checked={artCategories.includes(category)} onChange={() => toggleArt(category)} />
        <span>{category}</span>
      </label>)}</div>
      {!PROFESSIONS.some((category) => category.toLowerCase().includes(search.trim().toLowerCase())) && <p className="muted">No matching skills.</p>}
    </fieldset>
  </div>;
}
